import React, { useState } from "react";
// import { Modal, ModalBody, ModalDialog,ModalFooter, ModalHeader} from 'react-bootstrap';
import config from "react-global-configuration";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import "../assets/css/datatables/datatables.min.css";
import "../assets/css/react-confirm-alert/react-confirm-alert.css";
import Select from "react-select";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./css/ipos-navbar.css";
import "./css/TotalEMI.css";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import "react-calendar/dist/Calendar.css";
import Charts from "react-apexcharts";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import MobNavbar from "./js/BottomNav";
import { isMobile } from "react-device-detect";
import "./css/TotalEMI.css";
import TopNavbar from "ipos/js/TopNavbar";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Button } from 'react-bootstrap';
import srcgo from "../assets/img/msparc/Go.png";
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';
import jwt_decode from "jwt-decode";
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from "react-redux";
import SidebarComponent from "./js/Sidebar";

const override = css`
    position:absolute;
    display: inline-block;
    margin-left:35%;
    margin-top:100px;
    border-color: red;
    text-align: center;
`;
// const chartData = [
//   {
//     name: "Amount",
//     data: [],
//   },]
const closeIcon = (
  <svg fill="currentColor" viewBox="0 0 20 20" width={28} height={28}>
    <path
      fillRule="evenodd"
      d=""
      clipRule="evenodd"
    ></path>
  </svg>
)
const closeIcon1 = (
  <svg fill="currentColor" viewBox="0 0 20 20" width={28} height={28}>
    <path
      fillRule="evenodd"
      d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
      clipRule="evenodd"
    ></path>
  </svg>
)

const sendemailbutton = {
  textTransform: 'none',
  width: '100px',
  fontSize: '12px',
  padding: '10px 0px',
  borderRadius: '20px',
  border: '1px solid #9A9A9A',

}
const sendemailbuttonselected = {
  textTransform: 'none',
  width: '100px',
  fontSize: '12px',
  padding: '10px 0px',
  borderRadius: '20px',
  border: '1px solid #FA7626',
  color: '#FA7626',
  background: '#fff',
}


let userdetail = {
  userName: '',
  sessionId: '',
  merchantId: '',
  activeTerminal: 'All Terminals',
  allTerminals: [],
  currPage: '',
}

let filtertype = 'a';
let valuetype = ".00";
const moment = extendMoment(originalMoment);
const loadtoday = moment().subtract(6, "days");
const tempStartDate = moment().subtract(6, "d").format("YYYY-MM-DD" + " 00:00:00");
const tempEndDate = moment();
const maxDate = moment();
const reporttype = [
  { label: "Txn Amount", value: 0 },
  { label: "Txn Count", value: 1 },
  { label: "Debit Card Amount", value: 2 },
  { label: "Debit Card Count", value: 3 },
  { label: "Credit Card Amount", value: 4 },
  { label: "Credit Card Count", value: 5 },
  { label: "Bank EMI Amount", value: 6 },
  { label: "Bank EMI Count", value: 7 },
  { label: "Brand EMI Amount", value: 8 },
  { label: "Brand EMI Count", value: 9 },
];

var colors = [
  "#008FFB",
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#546E7A",
  "#26a69a",
  "#D10CE8",
];

class IposTrends extends React.Component {
  constructor(props) {
    super(props);

    const today = moment();
    this.state = {
      loasder: false,
      analysisType: '',
      terminalNo: '',
      sessionId: '',
      userName: '',
      merchantId: '',
      email: '',
      emailalert: false,
      ddltype: 'count',
      transactionDetails: [],
      avgAmount: '',
      maxAmount: '',
      dateFrom: null,
      dateTo: null,
      sidebar:false,
      preDefinedDates: [
        {
          label: "Last 7 days",
          startDate: moment()
            .subtract(6, "d")
            .format("YYYY-MM-DD" + " 00:00:00"),
          endDate: moment().format("YYYY-MM-DD hh:mm:ss"),
          selected: false
        },
        {
          label: "Last 30 days",
          startDate: moment()
            .subtract(29, "d")
            .format("YYYY-MM-DD" + " 00:00:00"),
          endDate: moment().format("YYYY-MM-DD hh:mm:ss"),
          selected: false
        },
        {
          label: "Current Month",
          startDate: moment()
            .startOf('month')
            .format("YYYY-MM-DD" + " 00:00:00"),
          endDate: moment().format("YYYY-MM-DD hh:mm:ss"),
          selected: false
        },
        {
          label: "Last month",
          startDate: moment()
            .subtract(1, "months")
            .startOf('month')
            .format("YYYY-MM-DD" + " 00:00:00"),
          endDate: moment()
            .subtract(1, "months")
            .endOf('month')
            .format("YYYY-MM-DD"),
          selected: false
        },
        {
          label: "Last 3 months",
          startDate: moment()
            .subtract(3, "months")
            .startOf('month')
            .format("YYYY-MM-DD" + " 00:00:00"),
          endDate: moment()
            .subtract(1, "months")
            .endOf('month')
            .format("YYYY-MM-DD hh:mm:ss"),
          selected: false
        },
        {
          label: "Last 6 months",
          startDate: moment()
            .subtract(6, "months")
            .startOf('month')
            .format("YYYY-MM-DD" + " 00:00:00"),
          endDate: moment()
            .subtract(1, "months")
            .endOf('month')
            .format("YYYY-MM-DD hh:mm:ss"),
          selected: false
        }
      ],
      loadstate: [
        {
          startDate: new Date(),
          endDate: null,
          key: "selection",
        },
      ],

      series: [
        {
          name: "Amount",
          data: [],
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val + valuetype;
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: colors,
          },
        },
        legend: {
          show: false,
        },
        title: {
          text: "",
          align: "center",
          fontSize: "18px",
          fontWeight: '700',
          fontFamily: 'Roboto'
        },
        xaxis: {
          title: {
            text: "Days",
            floating: true,
            offsetY: 8,
            align: "center",
            style: {
              color: "#444",
              fontSize: "14px",
              fontWeight: '700',
              fontFamily: 'Roboto'
            },
          },
          labels: {
            rotate: -45,
          },
          categories: [],
          labels: {
            style: {
              colors: colors,
              fontSize: "12px",
              fontWeight: '700',
              fontFamily: 'Roboto'
            },
          },
        },
        yaxis: {
          title: {
            text: "Amount (INR)",
            style: {
              color: "#444",
              fontSize: "14px",
              fontWeight: '700',
              fontFamily: 'Roboto'
            },
          },
        },
      },
      showmodal: false,
      showstmtmodal: false,
      dates: {
        startDate: new Date(),
        endDate: null,
      },
      isOpen: false,
      value: '',
      startDate: moment(tempStartDate),
      endDate: moment(),
      currTerminal: "All Terminals",
      allTerminals: [],
    };
  }

  componentWillMount() {
    this.fetchLoginData();
    this.props.currentMenu("totalemi");
  }
  componentDidMount() {
    // console.log(this.state.series[0].data[1])
  }
  fetchLoginData = () => {
    const decoded = jwt_decode(localStorage.usertoken);
    let phoneno = decoded.phone;
    // let phoneno = "9902922671";
    this.setState({ loader: true })
    axios
      .post(config.get("API_URL") + "/users/totalemi-login", {
        mobileNumber: phoneno,
        password: phoneno,
        userType: "Merchant"
      })
      .then((response) => {
        if (response.data.responseCode == "00") {
          let AllTerminals = JSON.parse(JSON.stringify(this.state.allTerminals))
          this.setState({
            terminalNo: response.data.responseDetails.userDetails.profile.terminals[0].utid,
            userName: response.data.responseDetails.userDetails.name,
            email: response.data.responseDetails.userDetails.email,
            sessionId: response.data.responseDetails.loginSessionDetails.loginSessionId,
            merchantId: response.data.responseDetails.userDetails.profile.merchantId,
            analysisType: "txnAmount",
          })
          userdetail.userName = response.data.responseDetails.userDetails.name;
          userdetail.sessionId = response.data.responseDetails.loginSessionDetails.loginSessionId;
          userdetail.merchantId = response.data.responseDetails.userDetails.profile.merchantId;
          userdetail.appVersion = "2.1";
          userdetail.allTerminals = AllTerminals;
          this.fetchTrendsdData();

          response.data.responseDetails.userDetails.profile.terminals.map((value, key) => {
            AllTerminals[key] = response.data.responseDetails.userDetails.profile.terminals[key].utid;
          })
          this.setState({ allTerminals: AllTerminals })

        }
        else { alert("User data is not onboarded on sparcs"); }
      });
  }
  fetchTrendsdData = () => {
    this.setState({ loader: true })

    axios
      .post(config.get("API_URL") + "/users/totalemi-trends", {
        startDate: moment(this.state.startDate).format("YYYY-MM-DD") + " 00:00:00",
        endDate: moment(this.state.endDate).format("YYYY-MM-DD") + " " + moment(new Date()).format("hh:mm:ss"),
        merchantId: this.state.merchantId.toString(),
        utid: userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal,// this.state.terminalNo,
        transactionFilter: this.state.analysisType,
        loginSessionId: this.state.sessionId,
        name: this.state.userName,
        appVersion: "2.1"
      })
      .then((response) => {
        if (response.data.responseCode == "00") {
          // console.log("trends response are :" + response.data.responseDetails.transactionDetails);
          this.setState({
            transactionDetails: response.data.responseDetails.transactionDetails,
            loader: false,
          })

          let newChartData = JSON.parse(JSON.stringify(this.state.series))
          let newdays = JSON.parse(JSON.stringify(this.state.options.xaxis.categories))
          newChartData[0].data.length = 0;
          newdays.length = 0;
          if (filtertype == 'Count') {

            this.setState({ avgAmount: response.data.responseDetails.avgCount, maxAmount: response.data.responseDetails.maxCount, })
            this.state.transactionDetails.map((value, index) => {
              newChartData[0].data.push(value.count);
              newdays.push(moment(value.dateTime).format("DD MMM"));
            })
            this.setState({ series: newChartData });
            this.setState(prevState => ({
              ...prevState,
              options: {
                ...prevState.options,
                xaxis: {
                  ...prevState.options.xaxis, categories: newdays
                },
                yaxis: {
                  ...prevState.options.yaxis, title: {
                    ...prevState.options.yaxis.title, text: "Count"
                  }
                },
              }
            }))
          }
          else {
            this.setState({ avgAmount: response.data.responseDetails.avgAmount, maxAmount: response.data.responseDetails.maxAmount, })
            this.state.transactionDetails.map((value, index) => {
              newChartData[0].data.push(value.txnAmount);
              newdays.push(moment(value.dateTime).format("DD MMM"));

            })
            this.setState({ series: newChartData });
            this.setState(prevState => ({
              ...prevState,
              options: {
                ...prevState.options,
                xaxis: {
                  ...prevState.options.xaxis, categories: newdays
                },
                yaxis: {
                  ...prevState.options.yaxis, title: {
                    ...prevState.options.yaxis.title, text: "Amount (INR)"
                  }
                },
              }
            }))

          }

        }
        else {
          alert("Some technical error occured!. Please try again");
        }

      });
  }
  sendEmail = () => {
    this.setState({ loader: true });

    axios
      .post(config.get("API_URL") + "/users/totalemi-emailStatement", {
        startDate: this.state.dateFrom,
        endDate: this.state.dateTo,
        merchantId: this.state.merchantId.toString(),
        utid: userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal,// this.state.terminalNo,
        email: this.state.email,
        loginSessionId: this.state.sessionId,
        name: this.state.userName,
        appVersion: "2.1"
      })
      .then((response) => {
        if (response.data.responseCode == "00") {
          this.setState({ showstmtmodal: false, emailalert: true, loader: false })
        }
        else {
          alert(response.data.responseMessage);
          this.setState({ showstmtmodal: true, loader: false })
        }

      });
  }
  onChange = (date) => {
    this.setState({ loadstate: date });
  };

  goBack = () => {
    this.props.history.push("/admin/brand-emi");
  };


  showRange = (AanalysisType) => {
    switch (AanalysisType.value) {
      case 0:
        this.setState({ analysisType: "txnAmount" });
        filtertype = 'Amount (INR)';
        valuetype = ".00";
        break;
      case 1:
        this.setState({ analysisType: "txnCount" });
        filtertype = 'Count';
        valuetype = "";
        break;
      case 2:
        this.setState({ analysisType: "debitAmount" });
        filtertype = 'Amount (INR)';
        valuetype = ".00";
        break;
      case 3:
        this.setState({ analysisType: "debitCount" });
        filtertype = 'Count';
        valuetype = "";
        break;
      case 4:
        this.setState({ analysisType: "creditAmount" });
        filtertype = 'Amount (INR)';
        valuetype = ".00";
        break;
      case 5:
        this.setState({ analysisType: "creditCount" });
        filtertype = 'Count';
        valuetype = "";
        break;
      case 6:
        this.setState({ analysisType: "bankEmiAmount" });
        filtertype = 'Amount (INR)';
        valuetype = ".00";
        break;
      case 7:
        this.setState({ analysisType: "bankEmiCount" });
        filtertype = 'Count';
        valuetype = "";
        break;
      case 8:
        this.setState({ analysisType: "brandEmiAmount" });
        filtertype = 'Amount (INR)';
        valuetype = ".00";
        break;
      case 9:
        this.setState({ analysisType: "brandEmiCount" });
        filtertype = 'Count';
        valuetype = "";
        break;

    }

  };
  changeChart = () => {
    // var inp = this.state.newdata[0].data;
    // for (let i = 0; i < inp.length; i++) {
    //     inp[i]=inp[i]+300;
    // }
    //this.setState({ sidebar:!this.state.sidebar});
    // console.log(this.state.newdata);
    this.fetchTrendsdData();
  };

  showModel = () => {
    this.setState({
      showmodal: !this.state.showmodal,
    });
  };

  showStmtModal = () => {
    this.setState({
      showstmtmodal: !this.state.showstmtmodal,
    })

  }

  onSelect = (value, states) => {
    this.setState({
      startDate: this.state.value.start,
      endDate: this.state.value.end,
    });
  };
  handleDateRangeSelectStart = (fromDate) => {
    this.setState({
      endDate: fromDate,
      startDate: moment(fromDate).subtract(6, "d"),
    });
  };

  onCloseModal = () => {
    this.setState({
      showmodal: !this.state.showmodal,
    });
  };

  onCloseStmtModal = () => {
    this.setState({
      showstmtmodal: !this.state.showstmtmodal,
    });
  };


  cancelDateChange = () => {
    this.setState({
      startDate: moment(tempStartDate),
      endDate: tempEndDate,
      showmodal: !this.state.showmodal,
    });
  };

  sentmail = () => {
    this.setState({
      showstmtmodal: !this.state.showstmtmodal,
    })

  }
  onDatesChange = (date) => {
    //   this.setState({
    //     startDate: moment(tempStartDate),
    //     endDate: tempEndDate,
    //   })
  };
  myCallback = (dataFromChild) => {
    let curr_dash_terminal = dataFromChild.trim().includes("All") ? "All Terminals" : dataFromChild.trim();
    this.setState({ currTerminal: curr_dash_terminal });
    userdetail.activeTerminal = curr_dash_terminal;
    this.fetchTrendsdData();
  }
  EmailDateRange = (stmtdate) => {
    let range = stmtdate.target.outerText.trim();

    let preDefinedDatesCopy = JSON.parse(JSON.stringify(this.state.preDefinedDates))
    preDefinedDatesCopy[0].selected = false;
    preDefinedDatesCopy[1].selected = false;
    preDefinedDatesCopy[2].selected = false;
    preDefinedDatesCopy[3].selected = false;
    preDefinedDatesCopy[4].selected = false;
    preDefinedDatesCopy[5].selected = false;


    switch (range) {
      case this.state.preDefinedDates[0].label.toString():
        preDefinedDatesCopy[0].selected = true;
        this.setState({ dateFrom: this.state.preDefinedDates[0].startDate, dateTo: this.state.preDefinedDates[0].endDate, preDefinedDates: preDefinedDatesCopy });
        break;
      case this.state.preDefinedDates[1].label.toString():
        preDefinedDatesCopy[1].selected = true;
        this.setState({ dateFrom: this.state.preDefinedDates[1].startDate, dateTo: this.state.preDefinedDates[1].endDate, preDefinedDates: preDefinedDatesCopy })
        break;
      case this.state.preDefinedDates[2].label.toString():
        preDefinedDatesCopy[2].selected = true;
        this.setState({ dateFrom: this.state.preDefinedDates[2].startDate, dateTo: this.state.preDefinedDates[2].endDate, preDefinedDates: preDefinedDatesCopy })
        break;
      case this.state.preDefinedDates[3].label.toString():
        preDefinedDatesCopy[3].selected = true;
        this.setState({ dateFrom: this.state.preDefinedDates[3].startDate, dateTo: this.state.preDefinedDates[3].endDate, preDefinedDates: preDefinedDatesCopy })
        break;
      case this.state.preDefinedDates[4].label.toString():
        preDefinedDatesCopy[4].selected = true;
        this.setState({ dateFrom: this.state.preDefinedDates[4].startDate, dateTo: this.state.preDefinedDates[4].endDate, preDefinedDates: preDefinedDatesCopy })
        break;
      case this.state.preDefinedDates[5].label.toString():
        preDefinedDatesCopy[5].selected = true;
        this.setState({ dateFrom: this.state.preDefinedDates[5].startDate, dateTo: this.state.preDefinedDates[5].endDate, preDefinedDates: preDefinedDatesCopy })
        break;
    }

  }

  render() {
    return (
      <>
       {this.state.sidebar && <SidebarComponent/>}
        {isMobile && <TopNavbar selectedterminals={this.state.currTerminal} allterminals={this.state.allTerminals} callbackFromParent={this.myCallback} />}
        <div className="fixed-content">
          <div className="container-fluid ">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12 p-top-10">
            
                <Modal
                  open={this.state.showmodal}
                  onClose={this.onCloseModal}
                  classNames={{
                    animationIn: 'customEnterAnimation',
                    animationOut: 'customLeaveAnimation',
                  }}
                  animationDuration={500}
                  closeIcon={closeIcon}
                  center
                >
                  <DateRangePicker
                    value={moment.range(
                      this.state.startDate,
                      this.state.endDate
                    )}
                    onSelectStart={this.handleDateRangeSelectStart}
                    singleDateRange={true}
                    maximumDate={moment()}
                  />
                  <div className="text-center">
                    <Button
                      style={{
                        background: "#ef7731",
                        color: "#fff",
                        borderRadius: "10px",
                        width: "80px",
                        margin: "5px",
                      }}
                      onClick={this.cancelDateChange}
                      align="center"
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{
                        background: "#ef7731",
                        color: "#fff",
                        borderRadius: "10px",
                        width: "80px",
                        margin: "5px",
                      }}
                      onClick={this.onCloseModal}
                      align="center"
                    >
                      Done
                    </Button>
                  </div>
                </Modal>

                <Modal
                  open={this.state.showstmtmodal}
                  onClose={this.onCloseStmtModal}
                  closeOnOverlayClick={false}
                  classNames={{
                    animationIn: 'customEnterAnimation',
                    animationOut: 'customLeaveAnimation',
                  }}
                  animationDuration={500}
                  center
                >

                  <p style={{ fontSize: '15px', color: '#F47626', fontWeight: '600', borderBottom: '1px solid', padding: '5px 0px 10px 0px' }}>Request for your Transaction Statement</p>
                  <p style={{ fontWeight: '600' }}>Select duration</p>
                  <div style={{ paddingBottom: '5px' }}>
                    <Button style={this.state.preDefinedDates[0].selected ? sendemailbuttonselected : sendemailbutton} onClick={this.EmailDateRange.bind(this)} >{this.state.preDefinedDates[0].label}</Button>{' '}
                    <Button style={this.state.preDefinedDates[1].selected ? sendemailbuttonselected : sendemailbutton} onClick={this.EmailDateRange.bind(this)} >{this.state.preDefinedDates[1].label}</Button>{' '}
                    <Button style={this.state.preDefinedDates[2].selected ? sendemailbuttonselected : sendemailbutton} onClick={this.EmailDateRange.bind(this)}>{this.state.preDefinedDates[2].label}</Button>{' '}
                  </div>
                  <div style={{ paddingBottom: '20px' }}>
                    <Button style={this.state.preDefinedDates[3].selected ? sendemailbuttonselected : sendemailbutton} onClick={this.EmailDateRange.bind(this)} >{this.state.preDefinedDates[3].label}</Button>{' '}
                    <Button style={this.state.preDefinedDates[4].selected ? sendemailbuttonselected : sendemailbutton} onClick={this.EmailDateRange.bind(this)} >{this.state.preDefinedDates[4].label}</Button>{' '}
                    <Button style={this.state.preDefinedDates[5].selected ? sendemailbuttonselected : sendemailbutton} onClick={this.EmailDateRange.bind(this)} >{this.state.preDefinedDates[5].label}</Button>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                    <p>From</p>
                    <div className="form-group ">
                      <div className="input-group date z-ind-0" style={{ border: '1px solid #9A9A9A', borderRadius: '5px' }}>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.dateFrom == null ? '' : moment(this.state.dateFrom).format("DD MMM YYYY")}
                          style={{ background: "#fff", color: "#666666", }}
                          readOnly
                        />
                        <span className="input-group-addon cal-pad">
                          <span className="fa fa-calendar" style={{ fontSize: '20px', width: '30px' }}></span>
                        </span>
                      </div>
                    </div>
                    <p>To</p>
                    <div className="form-group ">
                      <div className="input-group date z-ind-0" style={{ border: '1px solid #9A9A9A', borderRadius: '5px' }}>
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.dateTo == null ? '' : moment(this.state.dateTo).format("DD MMM YYYY")}
                          style={{ background: "#fff", color: "#666666", }}
                          readOnly
                        />
                        <span className="input-group-addon cal-pad">
                          <span className="fa fa-calendar" style={{ fontSize: '20px', width: '30px' }}></span>
                        </span>
                      </div>
                    </div>

                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 text-center">
                    <Button
                      style={{
                        background: "#ef7731",
                        color: "#fff",
                        borderRadius: "10px",
                        width: "100%",
                        padding: "10px",
                        textTransform: 'none'
                      }}
                      onClick={this.sendEmail}
                      align="center"
                    >Send Email</Button>
                  </div>

                </Modal>

                <SweetAlert
                  custom
                  show={this.state.emailalert}
                  // showCancel
                  // showCloseButton
                  confirmBtnText="OK"
                  // cancelBtnText="No"
                  confirmBtnBsStyle="default"
                  // cancelBtnBsStyle="default"
                  // customIcon="https://raw.githubusercontent.com/djorg83/react-bootstrap-sweetalert/master/demo/assets/thumbs-up.jpg"
                  title="Alert!"
                  onConfirm={() => { this.setState({ emailalert: false }) }}

                >
                  <p style={{ fontSize: '16px', color: '#FA7626' }}> Email sent successfully</p>
                </SweetAlert>
                <div className="content">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                      <div className="card">
                        <div className="content">
                          <div className="row">
                            <div
                              className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
                              style={{
                                borderBottom: "1px solid darkgray",
                                marginTop: "-15px",
                              }}
                            >
                              <h4
                                style={{ color: "#666666", fontSize: "120%" }}
                              >
                                Trends Analysis
                              </h4>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  m-tp-5">
                              <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 align-left p-0">
                                <p
                                  className="trendlbl"
                                  style={{ paddingTop: "8px" }}
                                >
                                  {" "}
                                  Select Analysis Type
                                </p>
                              </div>
                              <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 p-0">
                                <Select
                                  options={reporttype}
                                  onChange={this.showRange.bind(this)}
                                  defaultValue={{
                                    label: "Txn Amount",
                                    value: 0,
                                  }}
                                  className="selectSize"
                                  isSearchable={false}
                                />
                              </div>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-10 p-0"
                                style={{ padding: "0" }}
                              >
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 p-0">
                                  <p className="trendlbl">
                                    {" "}
                                    Select 7-Days Date Range
                                  </p>
                                </div>


                                <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 p-0">
                                  <div className="form-group ">
                                    <div className="input-group date z-ind-0" onClick={() =>
                                      this.setState({
                                        showmodal: !this.state.showmodal,
                                      })
                                    }>
                                      <input
                                        type="text"
                                        className="form-control selectSize"

                                        value={
                                          this.state.startDate.format(
                                            "DD MMM"
                                          ) +
                                          " - " +
                                          this.state.endDate.format(
                                            "DD MMM YYYY"
                                          )
                                        }
                                        style={{
                                          background: "#fff",
                                          color: "#666666",
                                          fontSize: "75%",
                                        }}
                                        readOnly
                                      />
                                      <span className="input-group-addon cal-pad">
                                        <span className="fa fa-calendar"></span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5">

                                <img
                                  src={srcgo}
                                  style={{ float: "right", width: "60px" }}
                                  onClick={this.changeChart}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                      <div className="card">
                        <div className="content" style={{ minHeight: '245px' }}>
                          {!this.state.loader === true ?
                            <div className="row">
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div
                                  className="col-lg-4 col-md-4 col-sm-4 col-xs-6 "
                                  style={{ float: "right", textAlign: "right" }}
                                >
                                  <p style={{ color: "#9a9a9a" }}>
                                    Average :{" "}
                                    <span style={{ color: "#E47D3E" }}>{this.state.avgAmount}</span>{" "}
                                  </p>
                                  <p style={{ color: "#9a9a9a" }}>
                                    Highest :{" "}
                                    <span style={{ color: "#E47D3E" }}>
                                      {this.state.maxAmount}.00
                                  </span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                <div
                                  className="col-lg-12 col-md-12 col-xs-12"
                                  style={{ borderBottom: "1px solid darkgray" }}
                                >

                                  <Charts
                                    options={this.state.options}
                                    series={this.state.series}
                                    type="bar"
                                    height={350}
                                  />


                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 dash-header text-center ">
                                  <label>
                                    For more than 7 days, click{" "}
                                    <span style={{ color: "darkorange" }} onClick={this.sentmail}>
                                      here
                                  </span>{" "}
                                  for Email Statement
                                </label>
                                </div>

                              </div>
                            </div>
                            :
                            <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={15}
                              color={'#123abc'}
                              loading={this.state.loader}
                            />
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    currentMenu: (name) => { dispatch({ type: 'change_menu', payload: name }) }
  }
}
export default connect(null, mapDispatchToProps)(IposTrends);
